export default "__VITE_ASSET__BAPdRN2Y__"